import http from "@/settings/apiSettings"

class ConBilantRanduriDataService{
  save(data: any): Promise<any> {
        return http.clientContabilitate.post("/CON_BilantRanduri", data);
      }
  
}
export default new ConBilantRanduriDataService();